"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = require("react-dom");
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var utils_1 = require("../../utils");
var DropContainer_1 = require("./DropContainer");
var Drop = /** @class */ (function (_super) {
    tslib_1.__extends(Drop, _super);
    function Drop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.originalFocusedElement = document.activeElement;
        _this.dropContainer = utils_1.getNewContainer();
        return _this;
    }
    Drop.prototype.componentWillUnmount = function () {
        var restrictFocus = this.props.restrictFocus;
        if (restrictFocus && this.originalFocusedElement) {
            utils_1.setFocusWithoutScroll(this.originalFocusedElement);
        }
        document.body.removeChild(this.dropContainer);
    };
    Drop.prototype.render = function () {
        var _a = this.props, dropTarget = _a.target, // avoid DOM leakage
        rest = tslib_1.__rest(_a, ["target"]);
        return react_dom_1.createPortal(React.createElement(DropContainer_1.DropContainer, tslib_1.__assign({ dropTarget: dropTarget }, rest)), this.dropContainer);
    };
    return Drop;
}(React.PureComponent));
var DropWrapper = recompose_1.compose(styled_components_1.withTheme)(Drop);
exports.Drop = DropWrapper;
//# sourceMappingURL=Drop.js.map